<template>
  <div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity"></div>
    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div class="flex min-h-full items-center justify-center p-4">
        <div class="relative transform overflow-hidden rounded-lg bg-gray-800 text-white shadow-xl transition-all sm:max-w-3xl w-full">
          <div class="p-6">
            <!-- หัวข้อและปุ่มปิด -->
            <div class="flex justify-between items-center mb-6">
              <h3 class="text-xl font-semibold text-indigo-300">เพิ่มไอเทมใหม่</h3>
              <button @click="$emit('cancelModal')" class="text-gray-400 hover:text-white">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <!-- ฟอร์ม -->
            <form @submit.prevent="handleAddItem">
              <!-- Tab Navigation -->
              <div class="flex border-b border-gray-600 mb-6">
                <button
                  type="button"
                  :class="['px-4 py-2 text-sm font-medium', activeTab === 1 ? 'border-b-2 border-indigo-500 text-indigo-300' : 'text-gray-400 hover:text-white']"
                  @click="activeTab = 1"
                >
                  ข้อมูลพื้นฐาน
                </button>
                <button
                  type="button"
                  :class="['px-4 py-2 text-sm font-medium', activeTab === 2 ? 'border-b-2 border-indigo-500 text-indigo-300' : 'text-gray-400 hover:text-white']"
                  @click="activeTab = 2"
                >
                  การแยกชิ้นส่วนและอัพเกรด
                </button>
              </div>
              <!-- Tab Content -->
              <div v-show="activeTab === 1" class="h-96 overflow-auto">
                <!-- ข้อมูลพื้นฐาน -->
                <div class="space-y-4 mb-6">
                  <h4 class="text-lg font-medium text-gray-300">ข้อมูลพื้นฐาน</h4>
                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">ชื่อไอเทม</label>
                      <input
                        v-model="newItem.name"
                        type="text"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">ลิงค์รูปภาพ</label>
                      <input
                        v-model="newItem.img"
                        type="url"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        placeholder="https://example.com/image.jpg"
                        required
                      >
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">ประเภทไอเทม</label>
                      <select
                        v-model="newItem.type"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                        <option value="หมวก">หมวก</option>
                        <option value="แว่นตา">แว่นตา</option>
                        <option value="เสื้อ">เสื้อ</option>
                        <option value="เสื้อคลุม">เสื้อคลุม</option>
                        <option value="เกราะ">เกราะ</option>
                        <option value="ปลอกแขน">ปลอกแขน</option>
                        <option value="ถุงมือ">ถุงมือ</option>
                        <option value="กางเกง">กางเกง</option>
                        <option value="สนับแข้ง">สนับแข้ง</option>
                        <option value="รองเท้า">รองเท้า</option>
                        <option value="เข็มขัด">เข็มขัด</option>
                        <option value="สร้อยคอ">สร้อยคอ</option>
                        <option value="แหวน">แหวน</option>
                        <option value="อาวุธ">อาวุธ</option>
                        <option value="อาวุธสำรอง">อาวุธสำรอง</option>
                        <option value="ตะกรุด">ตะกรุด</option>
                        <option value="ผ้ายันต์">ผ้ายันต์</option>
                        <option value="สายสิญจน์">สายสิญจน์</option>
                        <option value="หนังสือ">หนังสือ</option>
                        <option value="อาหาร">อาหาร</option>
                        <option value="แผนที่">แผนที่</option>
                        <option value="รักษา">รักษา</option>
                        <option value="กัปดัก">กัปดัก</option>
                        <option value="ระเบิด">ระเบิด</option>
                        <option value="ปลดกัปดัก">ปลดกัปดัก</option>
                        <option value="พาหนะ">พาหนะ</option>
                        <option value="วัสดุ">วัสดุ</option>
                        <option value="วัสดุวิญญาณ">วัสดุวิญญาณ</option>
                        <option value="วัสดุสิ่งมีชีวิตกลายพันธุ์">วัสดุสิ่งมีชีวิตกลายพันธุ์</option>
                        <option value="ทั่วไป">ทั่วไป</option>
                        <option value="กล่อง">กล่อง</option>
                        <option value="หุ่นยนต์สังหาร">หุ่นยนต์สังหาร</option>
                        <option value="อวัยวะจักรกล">อวัยวะจักรกล</option>
                        <option value="ปล้น">ปล้น</option>
                        <option value="การ์ด">การ์ด</option>
                        <option value="วิญญาณ">วิญญาณ</option>
                        <option value="สิ่งมีชีวิตกลายพันธุ์">สิ่งมีชีวิตกลายพันธุ์</option>
                        <option value="ไล่ผี">ไล่ผี</option>
                      </select>
                    </div>
                    <div v-if="newItem.type === 'วิญญาณ'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ประเภทย่อย</label>
                      <select
                        v-model="newItem.subtype"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                        <option value="วิญญาณเฝ้าห้อง">วิญญาณเฝ้าห้อง</option>
                        <option value="วิญญาณค้นหาผู้เล่น">วิญญาณค้นหาผู้เล่น</option>
                        <option value="วิญญาณผู้พิทักษ์">วิญญาณผู้พิทักษ์</option>
                        <option value="วิญญาณดูดทรัพย์">วิญญาณดูดทรัพย์</option>
                      </select>
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">เลเวลที่สามารถใส่ได้</label>
                      <input
                        v-model.number="newItem.requiredLevel"
                        type="number"
                        min="1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">น้ำหนัก (กก.)</label>
                      <input
                        v-model.number="newItem.weight"
                        type="number"
                        min="0"
                        step="0.1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">สามารถสวมใส่ได้?</label>
                      <select
                        v-model="newItem.wearable"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                        :disabled="newItem.type === 'ปล้น'"
                      >
                        <option :value="true">ใช่</option>
                        <option :value="false">ไม่</option>
                      </select>
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">สามารถโอนให้ผู้เล่นคนอื่นได้?</label>
                      <select
                        v-model="newItem.transfer"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                        <option :value="true">ใช่</option>
                        <option :value="false">ไม่</option>
                      </select>
                    </div>
                    <!-- Additional inputs for food type -->
                    <div v-if="newItem.type === 'อาหาร'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ระดับอาหาร</label>
                      <input
                        v-model.number="newItem.foodLevel"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="newItem.type === 'อาหาร'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ระดับความสุข</label>
                      <input
                        v-model.number="newItem.happinessLevel"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="newItem.type === 'อาหาร'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ระดับพลังงาน</label>
                      <input
                        v-model.number="newItem.energyLevel"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Additional inputs for healing type -->
                    <div v-if="newItem.type === 'รักษา'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">HP ที่ได้รับเมื่อรักษา (%)</label>
                      <input
                        v-model.number="newItem.healHpPercentage"
                        type="number"
                        min="0"
                        max="100"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="newItem.type === 'รักษา'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">การรักษาติดเชื้อไวรัส (%)</label>
                      <input
                        v-model.number="newItem.virusHealPercentage"
                        type="number"
                        min="0"
                        max="100"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Additional inputs for trap type -->
                    <div v-if="newItem.type === 'กัปดัก'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนลูกเต๋า</label>
                      <input
                        v-model.number="newItem.diceCount"
                        type="number"
                        min="1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="newItem.type === 'กัปดัก'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">สร้างความเสียหาย</label>
                      <input
                        v-model.number="newItem.damage"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="newItem.type === 'กัปดัก'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ระยะเวลาชั่วโมง</label>
                      <input
                        v-model.number="newItem.durationHours"
                        type="number"
                        min="0"
                        step="0.1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="newItem.type === 'กัปดัก'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนครั้งที่ใช้งานได้</label>
                      <input
                        v-model.number="newItem.useCount"
                        type="number"
                        min="1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Additional inputs for bomb type -->
                    <div v-if="newItem.type === 'ระเบิด'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ความเสียหายที่จะได้รับ</label>
                      <input
                        v-model.number="newItem.damage"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Additional input for vehicle type -->
                    <div v-if="newItem.type === 'พาหนะ'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ระดับน้ำมัน</label>
                      <input
                        v-model.number="newItem.fuelLevel"
                        type="number"
                        min="1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Additional input for book type -->
                    <div v-if="newItem.type === 'หนังสือ'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ลำดับ</label>
                      <input
                        v-model.number="newItem.order"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Additional inputs for disarm trap type -->
                    <div v-if="newItem.type === 'ปลดกัปดัก'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนห้องที่สามารถปลดกัปดักได้</label>
                      <input
                        v-model.number="newItem.disarmRoomCount"
                        type="number"
                        min="1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Additional inputs for killer robot type -->
                    <div v-if="newItem.type === 'หุ่นยนต์สังหาร'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">น้ำหนักที่หุ่นยนต์สามารถรับได้ (กก.)</label>
                      <input
                        v-model.number="newItem.maxLoad"
                        type="number"
                        min="0"
                        step="0.1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Additional inputs for loot type -->
                    <div v-if="newItem.type === 'ปล้น'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ระยะเวลาที่ต้องรอ (นาที)</label>
                      <input
                        v-model.number="newItem.waitTimeMinutes"
                        type="number"
                        min="0"
                        step="1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="newItem.type === 'ปล้น'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนไอเทมที่ปล้นได้ขั้นต่ำ</label>
                      <input
                        v-model.number="newItem.minLootItems"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="newItem.type === 'ปล้น'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนไอเทมที่ปล้นได้ขั้นสูงสุด</label>
                      <input
                        v-model.number="newItem.maxLootItems"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="newItem.type === 'ปล้น'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนเหรียญที่ได้รับหลังชนะ</label>
                      <input
                        v-model.number="newItem.silverReward"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="newItem.type === 'ปล้น'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนทองที่ได้รับหลังชนะ</label>
                      <input
                        v-model.number="newItem.goldReward"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="newItem.type === 'ปล้น'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนเพชรที่ได้รับหลังชนะ</label>
                      <input
                        v-model.number="newItem.diamondReward"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Additional inputs for card type -->
                    <div v-if="newItem.type === 'การ์ด'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ชื่ออวัยวะจักรกลที่สามารถติดตั้งการ์ดได้</label>
                      <select
                        v-model="newItem.compatibleEquipment"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                        <option value="" disabled>เลือกอวัยวะจักรกล</option>
                        <option value="ขาจักรกล">ขาจักรกล</option>
                        <option value="ซี่โครงจักรกล">ซี่โครงจักรกล</option>
                        <option value="ดวงตาจักรกล">ดวงตาจักรกล</option>
                        <option value="สมองจักรกล">สมองจักรกล</option>
                        <option value="หมัดจักรกล">หมัดจักรกล</option>
                        <option value="หัวใจจักรกล">หัวใจจักรกล</option>
                        <option value="แขนจักรกล">แขนจักรกล</option>
                        <option value="ลำตัวจักรกล">ลำตัวจักรกล</option>
                        <option value="สะโพกจักรกล">สะโพกจักรกล</option>
                        <option value="ตาหลังจักรกล">ตาหลังจักรกล</option>
                        <option value="กรามจักรกล">กรามจักรกล</option>
                        <option value="ไหล่จักรกล">ไหล่จักรกล</option>
                        <option value="จมูกจักรกล">จมูกจักรกล</option>
                        <option value="หูจักรกล">หูจักรกล</option>
                        <option value="ปีกจักรกล">ปีกจักรกล</option>
                        <option value="หนวดจักรกล">หนวดจักรกล</option>
                        <option value="เขาจักรกล">เขาจักรกล</option>
                      </select>
                    </div>
                    <!-- Explorable maps for killer robot type -->
                    <div v-if="newItem.type === 'หุ่นยนต์สังหาร'" class="mt-4 space-y-3">
                      <label class="block text-sm font-medium mb-1 text-gray-300">สถานที่ที่สามารถส่งหุ่นยนต์ไปได้</label>
                      <div v-for="(map, index) in newItem.explorableMaps" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                        <div class="col-span-10 sm:col-span-10">
                          <input
                            v-model="newItem.explorableMaps[index]"
                            type="text"
                            placeholder="ชื่อสถานที่"
                            class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          >
                        </div>
                        <div class="col-span-2">
                          <button
                            v-if="index > 0"
                            @click="removeExplorableMap(index)"
                            type="button"
                            class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                            aria-label="ลบสถานที่"
                          >
                            ลบ
                          </button>
                        </div>
                      </div>
                      <div class="flex gap-3 mt-3">
                        <button
                          @click="addExplorableMap"
                          type="button"
                          class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                        >
                          + เพิ่มสถานที่
                        </button>
                      </div>
                    </div>
                    <!-- Additional inputs for spirit subtypes -->
                    <div v-if="newItem.type === 'วิญญาณ' && newItem.subtype === 'วิญญาณเฝ้าห้อง'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ระยะเวลาที่เฝ้า (ชั่วโมง)</label>
                      <input
                        v-model.number="newItem.guardDurationHours"
                        type="number"
                        min="0"
                        step="0.1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="newItem.type === 'วิญญาณ' && newItem.subtype === 'วิญญาณเฝ้าห้อง'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">วิญญาณจากแผนที่</label>
                      <input
                        v-model="newItem.fromMap"
                        type="text"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        placeholder="ชื่อแผนที่ (ใส่ได้แผนที่เดียว)"
                        required
                      >
                    </div>
                    <div v-if="newItem.type === 'วิญญาณ' && newItem.subtype === 'วิญญาณเฝ้าห้อง'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนวิญญาณขั้นต่ำ</label>
                      <input
                        v-model.number="newItem.minSpirits"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="newItem.type === 'วิญญาณ' && newItem.subtype === 'วิญญาณเฝ้าห้อง'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนวิญญาณสูงสุด</label>
                      <input
                        v-model.number="newItem.maxSpirits"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="newItem.type === 'วิญญาณ' && newItem.subtype === 'วิญญาณค้นหาผู้เล่น'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนห้องที่ถูกคัดออก</label>
                      <input
                        v-model.number="newItem.eliminatedRooms"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="newItem.type === 'วิญญาณ' && newItem.subtype === 'วิญญาณผู้พิทักษ์'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนเกราะที่สามารถป้องกันได้</label>
                      <input
                        v-model.number="newItem.protectCount"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="newItem.type === 'วิญญาณ' && newItem.subtype === 'วิญญาณผู้พิทักษ์'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ระยะเวลาคุ้มกัน (ชั่วโมง)</label>
                      <input
                        v-model.number="newItem.protectDurationHours"
                        type="number"
                        min="0"
                        step="0.1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="newItem.type === 'วิญญาณ' && newItem.subtype === 'วิญญาณดูดทรัพย์'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนปล้นเพชรขั้นต่ำ</label>
                      <input
                        v-model.number="newItem.minDiamondLoot"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <div v-if="newItem.type === 'วิญญาณ' && newItem.subtype === 'วิญญาณดูดทรัพย์'">
                      <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนปล้นเพชรขั้นสูงสุด</label>
                      <input
                        v-model.number="newItem.maxDiamondLoot"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Cooldown input for specific spirit subtypes -->
                    <div v-if="newItem.type === 'วิญญาณ' && ['วิญญาณเฝ้าห้อง', 'วิญญาณผู้พิทักษ์', 'วิญญาณดูดทรัพย์'].includes(newItem.subtype)">
                      <label class="block text-sm font-medium mb-1 text-gray-300">ระยะเวลาคูดาวน์การใช้ครั้งถัดไป (ชั่วโมง)</label>
                      <input
                        v-model.number="newItem.cooldownHours"
                        type="number"
                        min="0"
                        step="0.1"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                    </div>
                    <!-- Required previous spirits for spirit type -->
                    <div v-if="newItem.type === 'วิญญาณ'" class="mt-4 space-y-3">
                      <label class="block text-sm font-medium mb-1 text-gray-300">วิญญาณที่ต้องเคยอัญเชิญมาก่อน</label>
                      <div v-for="(spirit, index) in newItem.requiredPreviousSpirits" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                        <div class="col-span-10 sm:col-span-10">
                          <input
                            v-model="newItem.requiredPreviousSpirits[index]"
                            type="text"
                            placeholder="ชื่อวิญญาณ"
                            class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          >
                        </div>
                        <div class="col-span-2">
                          <button
                            v-if="index > 0"
                            @click="removeRequiredPreviousSpirit(index)"
                            type="button"
                            class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                            aria-label="ลบวิญญาณ"
                          >
                            ลบ
                          </button>
                        </div>
                      </div>
                      <div class="flex gap-3 mt-3">
                        <button
                          @click="addRequiredPreviousSpirit"
                          type="button"
                          class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                        >
                          + เพิ่มวิญญาณ
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- คุณสมบัติ -->
                  <div class="space-y-4 mb-6">
                    <h4 class="text-lg font-medium text-gray-300">คุณสมบัติ</h4>
                    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">ระดับดาว</label>
                        <select
                          v-model.number="newItem.rarity"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          required
                        >
                          <option value="" disabled>เลือกระดับดาว</option>
                          <option value="0">0 ดาว</option>
                          <option value="1">1 ดาว</option>
                          <option value="2">2 ดาว</option>
                          <option value="3">3 ดาว</option>
                          <option value="4">4 ดาว</option>
                          <option value="5">5 ดาว</option>
                          <option value="6">6 ดาว</option>
                          <option value="7">7 ดาว</option>
                          <option value="8">8 ดาว</option>
                          <option value="9">9 ดาว</option>
                          <option value="10">10 ดาว</option>
                          <option value="11">11 ดาว</option>
                          <option value="12">12 ดาว</option>
                          <option value="13">13 ดาว</option>
                          <option value="14">14 ดาว</option>
                          <option value="15">15 ดาว</option>
                          <option value="16">16 ดาว</option>
                          <option value="17">17 ดาว</option>
                          <option value="18">18 ดาว</option>
                          <option value="19">19 ดาว</option>
                          <option value="20">20 ดาว</option>
                        </select>
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">ราคา</label>
                        <input
                          v-model.number="newItem.price"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          required
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">ประเภทหน่วยเงิน</label>
                        <select
                          v-model="newItem.currencyType"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          required
                        >
                          <option value="silver">Silver</option>
                          <option value="gold">Gold</option>
                          <option value="diamond">Diamond</option>
                        </select>
                      </div>
                      <div class="sm:col-span-3">
                        <label class="block text-sm font-medium mb-1 text-gray-300">คำอธิบาย</label>
                        <textarea
                          v-model="newItem.description"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          rows="2"
                          placeholder="อธิบายคุณสมบัติหรือเรื่องราวของไอเทม"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <!-- ค่าสถานะ -->
                  <div v-if="newItem.type !== 'ปลดกัปดัก' && newItem.type !== 'ปล้น'" class="space-y-4 mb-6">
                    <h4 class="text-lg font-medium text-gray-300">ค่าสถานะ</h4>
                    <div class="grid grid-cols-2 sm:grid-cols-5 gap-4">
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Stamina</label>
                        <input
                          v-model.number="newItem.stats.stamina"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Strength</label>
                        <input
                          v-model.number="newItem.stats.str"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Intelligence</label>
                        <input
                          v-model.number="newItem.stats.int"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Agility</label>
                        <input
                          v-model.number="newItem.stats.agi"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Luck</label>
                        <input
                          v-model.number="newItem.stats.luck"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Max HP</label>
                        <input
                          v-model.number="newItem.stats.maxHp"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Attack</label>
                        <input
                          v-model.number="newItem.stats.atk"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Evasion</label>
                        <input
                          v-model.number="newItem.stats.evasion"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Critical</label>
                        <input
                          v-model.number="newItem.stats.critical"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                      <div>
                        <label class="block text-sm font-medium mb-1 text-gray-300">Defense</label>
                        <input
                          v-model.number="newItem.stats.defense"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="activeTab === 2">
                <!-- การแยกชิ้นส่วนและอัพเกรด -->
                <div class="space-y-4 mb-6 max-h-96 overflow-auto" id="style-1">
                  <h4 class="text-lg font-medium text-gray-300">การแยกชิ้นส่วนและอัพเกรด</h4>
                  <div class="grid grid-cols-1 gap-4">
                    <!-- ส่วนแยกชิ้นส่วน -->
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">สามารถแยกชิ้นส่วนได้?</label>
                      <select
                        v-model="newItem.decomposable"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                        <option :value="true">ใช่</option>
                        <option :value="false">ไม่</option>
                      </select>
                      <div v-if="newItem.decomposable" class="mt-2 space-y-3 h-40 overflow-auto" id="style-1">
                        <div v-for="(decompose, index) in newItem.decomposeList" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                          <div class="col-span-6 sm:col-span-7">
                            <input
                              v-model="decompose.itemName"
                              type="text"
                              placeholder="ชื่อไอเทมที่ได้"
                              class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            >
                          </div>
                          <div class="col-span-4 sm:col-span-3">
                            <input
                              v-model.number="decompose.chance"
                              type="number"
                              min="0"
                              max="100"
                              placeholder="โอกาส (%)"
                              class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            >
                          </div>
                          <div class="col-span-2">
                            <button
                              v-if="index > 0"
                              @click="removeDecompose(index)"
                              type="button"
                              class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                              aria-label="ลบไอเทม"
                            >
                              ลบ
                            </button>
                          </div>
                        </div>
                        <div class="flex gap-3 mt-3">
                          <button
                            @click="addDecompose"
                            type="button"
                            class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                          >
                            + เพิ่มไอเทม
                          </button>
                        </div>
                        <div v-if="totalDecomposeChance > 0" class="text-sm text-gray-400 mt-2">
                          <p>โอกาสการแยกชิ้นส่วน (รวม: {{ totalDecomposeChance.toFixed(2) }}%):</p>
                          <ul class="list-disc list-inside">
                            <li v-for="(decompose, index) in newItem.decomposeList" :key="index">
                              {{ decompose.itemName || 'ยังไม่ระบุ' }}: {{ decompose.chance || 0 }}%
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <!-- ส่วนอัพเกรด -->
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">สามารถอัพเกรดได้?</label>
                      <select
                        v-model="newItem.upgradable"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        required
                      >
                        <option :value="true">ใช่</option>
                        <option :value="false">ไม่</option>
                      </select>
                      <div v-if="newItem.upgradable" class="mt-2 space-y-2">
                        <input
                          v-model="newItem.upgradeTo"
                          type="text"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          placeholder="ชื่อไอเทมถัดไป"
                        >
                        <input
                          v-model.number="newItem.upgradeChance"
                          type="number"
                          min="0"
                          max="100"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          placeholder="โอกาสสำเร็จ (%)"
                        >
                      </div>
                    </div>
                    <!-- Additional section for killer robot type -->
                    <div v-if="newItem.type === 'หุ่นยนต์สังหาร'">
                      <div class="mt-4 space-y-3">
                        <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนครั้งที่อัปเกรดได้</label>
                        <input
                          v-model.number="newItem.maxUpgradeCount"
                          type="number"
                          min="0"
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          required
                        >
                        <label class="block text-sm font-medium mb-1 text-gray-300">ไอเทมที่ใช้ในการอัปเกรด</label>
                        <div v-for="(material, index) in newItem.upgradeMaterials" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                          <div class="col-span-6 sm:col-span-7">
                            <input
                              v-model="material.itemName"
                              type="text"
                              placeholder="ชื่อไอเทม"
                              class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            >
                          </div>
                          <div class="col-span-4 sm:col-span-3">
                            <input
                              v-model.number="material.quantity"
                              type="number"
                              min="0"
                              placeholder="จำนวน"
                              class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            >
                          </div>
                          <div class="col-span-2">
                            <button
                              v-if="index > 0"
                              @click="removeUpgradeMaterial(index)"
                              type="button"
                              class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                              aria-label="ลบไอเทม"
                            >
                              ลบ
                            </button>
                          </div>
                        </div>
                        <div class="flex gap-3 mt-3">
                          <button
                            @click="addUpgradeMaterial"
                            type="button"
                            class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                          >
                            + เพิ่มไอเทม
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Additional section for cybernetic organ type -->
                    <div v-if="newItem.type === 'อวัยวะจักรกล'">
                      <div class="mt-4 space-y-3">
                        <label class="block text-sm font-medium mb-1 text-gray-300">ค่าสถานะที่สามารถอัปเกรดได้</label>
                        <select
                          v-model="newItem.upgradeableStats"
                          multiple
                          class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          required
                        >
                          <option value="stamina">Stamina</option>
                          <option value="str">Strength</option>
                          <option value="int">Intelligence</option>
                          <option value="agi">Agility</option>
                        </select>
                        <p class="text-sm text-gray-400">กด Ctrl (หรือ Cmd) ค้างเพื่อเลือกหลายตัวเลือก</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- ปุ่มควบคุม -->
              <div class="flex justify-end gap-3">
                <button
                  type="submit"
                  class="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                >
                  เพิ่มไอเทม
                </button>
                <button
                  @click="$emit('cancelModal')"
                  type="button"
                  class="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 transition duration-200"
                >
                  ยกเลิก
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch } from 'vue';
import { projectFirestore } from '@/firebase/config';

export default {
  emits: ['cancelModal', 'itemAdded'],
  setup(props, { emit }) {
    const activeTab = ref(1);
    const newItem = ref({
      name: '',
      img: '',
      type: 'วัสดุวิญญาณ',
      subtype: '',
      requiredLevel: 1,
      weight: 2,
      wearable: false,
      transfer: false,
      rarity: 13,
      price: 1000,
      currencyType: 'silver',
      description: '',
      upgradable: false,
      upgradeTo: '',
      upgradeChance: 0,
      decomposable: false,
      decomposeList: [{ itemName: '', chance: 0 }],
      stats: {
        stamina: 0,
        str: 0,
        int: 0,
        agi: 0,
        luck: 0,
        maxHp: 0,
        atk: 0,
        evasion: 0,
        critical: 0,
        defense: 0
      },
      createdAt: new Date(),
      foodLevel: 0,
      happinessLevel: 0,
      energyLevel: 0,
      healHpPercentage: 0,
      virusHealPercentage: 0,
      diceCount: 1,
      damage: 0,
      durationHours: 0,
      useCount: 1,
      fuelLevel: 1,
      maxUpgradeCount: 0,
      upgradeMaterials: [{ itemName: '', quantity: 0 }],
      upgradeableStats: [],
      disarmRoomCount: 1,
      maxLoad: 0,
      explorableMaps: [''],
      order: 0,
      waitTimeMinutes: 0,
      minLootItems: 0,
      maxLootItems: 0,
      silverReward: 0,
      goldReward: 0,
      diamondReward: 0,
      compatibleEquipment: '',
      guardDurationHours: 0,
      fromMap: '',
      minSpirits: 0,
      maxSpirits: 0,
      cooldownHours: 0,
      eliminatedRooms: 0,
      protectCount: 0,
      protectDurationHours: 0,
      minDiamondLoot: 0,
      maxDiamondLoot: 0,
      requiredPreviousSpirits: ['']
    });

    // Watch type to set wearable for loot type
    watch(() => newItem.value.type, (newType) => {
      if (newType === 'ปล้น') {
        newItem.value.wearable = true;
      }
    });

    // Calculate total decompose chance
    const totalDecomposeChance = computed(() =>
      newItem.value.decomposeList.reduce((sum, d) => sum + (d.chance || 0), 0)
    );

    const addDecompose = () => {
      newItem.value.decomposeList.push({ itemName: '', chance: 0 });
    };

    const removeDecompose = (index) => {
      if (newItem.value.decomposeList.length > 1) {
        newItem.value.decomposeList.splice(index, 1);
      }
    };

    const addUpgradeMaterial = () => {
      if (newItem.value.type === 'หุ่นยนต์สังหาร') {
        newItem.value.upgradeMaterials.push({ itemName: '', quantity: 0 });
      }
    };

    const removeUpgradeMaterial = (index) => {
      if (newItem.value.type === 'หุ่นยนต์สังหาร' && newItem.value.upgradeMaterials.length > 1) {
        newItem.value.upgradeMaterials.splice(index, 1);
      }
    };

    const addExplorableMap = () => {
      if (newItem.value.type === 'หุ่นยนต์สังหาร') {
        newItem.value.explorableMaps.push('');
      }
    };

    const removeExplorableMap = (index) => {
      if (newItem.value.type === 'หุ่นยนต์สังหาร' && newItem.value.explorableMaps.length > 1) {
        newItem.value.explorableMaps.splice(index, 1);
      }
    };

    const addRequiredPreviousSpirit = () => {
      if (newItem.value.type === 'วิญญาณ') {
        newItem.value.requiredPreviousSpirits.push('');
      }
    };

    const removeRequiredPreviousSpirit = (index) => {
      if (newItem.value.type === 'วิญญาณ' && newItem.value.requiredPreviousSpirits.length > 1) {
        newItem.value.requiredPreviousSpirits.splice(index, 1);
      }
    };

    // Get rarity colors based on rarity value
    const getRarityColors = (rarity) => {
      let effectiveRarity = Number(rarity);
      if (effectiveRarity > 10) {
        effectiveRarity = 10;
      }
      switch (effectiveRarity) {
        case 1: return { bgColor: 'bg-gray-500', textColor: 'text-gray-500', borderColor: 'border-gray-600' };
        case 2: return { bgColor: 'bg-stone-500', textColor: 'text-stone-500', borderColor: 'border-stone-600' };
        case 3: return { bgColor: 'bg-green-500', textColor: 'text-green-500', borderColor: 'border-green-600' };
        case 4: return { bgColor: 'bg-blue-500', textColor: 'text-blue-500', borderColor: 'border-blue-600' };
        case 5: return { bgColor: 'bg-red-500', textColor: 'text-red-500', borderColor: 'border-red-600' };
        case 6: return { bgColor: 'bg-purple-500', textColor: 'text-purple-500', borderColor: 'border-purple-600' };
        case 7: return { bgColor: 'bg-orange-500', textColor: 'text-orange-500', borderColor: 'border-orange-600' };
        case 8: return { bgColor: 'bg-pink-500', textColor: 'text-pink-500', borderColor: 'border-pink-600' };
        case 9: return { bgColor: 'bg-yellow-500', textColor: 'text-yellow-500', borderColor: 'border-yellow-600' };
        case 10: return { bgColor: 'bg-amber-500', textColor: 'text-amber-500', borderColor: 'border-amber-600' };
        default: return { bgColor: 'bg-gray-700', textColor: 'text-gray-500', borderColor: 'border-gray-600' };
      }
    };

    // Handle adding new item
    const handleAddItem = async () => {
      try {
        const itemName = newItem.value.name.trim();
        if (!itemName || /[/\.#$$$ $$]/.test(itemName)) {
          alert('ชื่อไอเทมไม่ถูกต้อง ห้ามใช้ / . # $ [ ] หรือปล่อยว่าง');
          return;
        }

        // ✅ ตรวจสอบชื่อซ้ำก่อนสร้าง
        const existingDoc = await projectFirestore.collection('gameItems').doc(itemName).get();
        if (existingDoc.exists) {
          alert(`ไอเทมชื่อ "${itemName}" มีอยู่แล้วในระบบ กรุณาใช้ชื่ออื่น`);
          return;
        }

        if (newItem.value.decomposable && newItem.value.decomposeList.every(d => !d.itemName || d.chance <= 0)) {
          alert('กรุณากรอกชื่อไอเทมและโอกาสที่มากกว่า 0 สำหรับการแยกชิ้นส่วนอย่างน้อยหนึ่งรายการ');
          return;
        }

        const rarityColors = getRarityColors(newItem.value.rarity);

        // Filter valid decompose list
        const normalizedDecomposeList = newItem.value.decomposable
          ? newItem.value.decomposeList.filter(d => d.itemName && d.chance > 0)
          : [];

        // Filter valid upgrade materials for killer robot only
        const filteredUpgradeMaterials = newItem.value.type === 'หุ่นยนต์สังหาร'
          ? newItem.value.upgradeMaterials.filter(m => m.itemName && m.quantity > 0)
          : [];

        // Filter valid explorable maps
        const filteredExplorableMaps = newItem.value.type === 'หุ่นยนต์สังหาร'
          ? newItem.value.explorableMaps.filter(map => map.trim())
          : [];

        // Filter valid required previous spirits
        const filteredRequiredPreviousSpirits = newItem.value.type === 'วิญญาณ'
          ? newItem.value.requiredPreviousSpirits.filter(spirit => spirit.trim())
          : [];

        // Use compatibleEquipment directly for card type
        const filteredCompatibleEquipment = newItem.value.type === 'การ์ด'
          ? newItem.value.compatibleEquipment || null
          : null;

        const newItemData = {
          name: itemName,
          img: newItem.value.img,
          type: newItem.value.type,
          subtype: newItem.value.type === 'วิญญาณ' ? newItem.value.subtype : null,
          requiredLevel: newItem.value.requiredLevel,
          weight: newItem.value.weight,
          wearable: newItem.value.wearable,
          transfer: newItem.value.transfer,
          rarity: Number(newItem.value.rarity),
          currencyType: newItem.value.currencyType || 'silver',
          rarityColors: rarityColors,
          price: newItem.value.price,
          description: newItem.value.description || '',
          upgradable: newItem.value.upgradable,
          upgradeTo: newItem.value.upgradable ? newItem.value.upgradeTo || '' : null,
          upgradeChance: newItem.value.upgradable ? newItem.value.upgradeChance || 0 : null,
          decomposable: newItem.value.decomposable,
          decomposeList: newItem.value.decomposable ? normalizedDecomposeList : [],
          stats: newItem.value.type === 'ปลดกัปดัก' || newItem.value.type === 'ปล้น' ? null : newItem.value.stats,
          createdAt: new Date(),
          foodLevel: newItem.value.type === 'อาหาร' ? newItem.value.foodLevel : null,
          happinessLevel: newItem.value.type === 'อาหาร' ? newItem.value.happinessLevel : null,
          energyLevel: newItem.value.type === 'อาหาร' ? newItem.value.energyLevel : null,
          healHpPercentage: newItem.value.type === 'รักษา' ? newItem.value.healHpPercentage : null,
          virusHealPercentage: newItem.value.type === 'รักษา' ? newItem.value.virusHealPercentage : null,
          diceCount: newItem.value.type === 'กัปดัก' ? newItem.value.diceCount : null,
          damage: ['กัปดัก', 'ระเบิด'].includes(newItem.value.type) ? newItem.value.damage : null,
          durationHours: newItem.value.type === 'กัปดัก' ? newItem.value.durationHours : null,
          useCount: newItem.value.type === 'กัปดัก' ? newItem.value.useCount : null,
          fuelLevel: newItem.value.type === 'พาหนะ' ? newItem.value.fuelLevel : null,
          maxUpgradeCount: newItem.value.type === 'หุ่นยนต์สังหาร' ? newItem.value.maxUpgradeCount : null,
          upgradeMaterials: filteredUpgradeMaterials,
          upgradeableStats: newItem.value.type === 'อวัยวะจักรกล' ? newItem.value.upgradeableStats : [],
          order: newItem.value.type === 'หนังสือ' ? newItem.value.order : null,
          disarmRoomCount: newItem.value.type === 'ปลดกัปดัก' ? newItem.value.disarmRoomCount : null,
          maxLoad: newItem.value.type === 'หุ่นยนต์สังหาร' ? newItem.value.maxLoad : null,
          explorableMaps: filteredExplorableMaps,
          waitTimeMinutes: newItem.value.type === 'ปล้น' ? newItem.value.waitTimeMinutes : null,
          minLootItems: newItem.value.type === 'ปล้น' ? newItem.value.minLootItems : null,
          maxLootItems: newItem.value.type === 'ปล้น' ? newItem.value.maxLootItems : null,
          silverReward: newItem.value.type === 'ปล้น' ? newItem.value.silverReward : null,
          goldReward: newItem.value.type === 'ปล้น' ? newItem.value.goldReward : null,
          diamondReward: newItem.value.type === 'ปล้น' ? newItem.value.diamondReward : null,
          compatibleEquipment: filteredCompatibleEquipment,
          requiredPreviousSpirits: filteredRequiredPreviousSpirits,
          guardDurationHours: newItem.value.type === 'วิญญาณ' && newItem.value.subtype === 'วิญญาณเฝ้าห้อง' ? newItem.value.guardDurationHours : null,
          fromMap: newItem.value.type === 'วิญญาณ' && newItem.value.subtype === 'วิญญาณเฝ้าห้อง' ? newItem.value.fromMap : null,
          minSpirits: newItem.value.type === 'วิญญาณ' && newItem.value.subtype === 'วิญญาณเฝ้าห้อง' ? newItem.value.minSpirits : null,
          maxSpirits: newItem.value.type === 'วิญญาณ' && newItem.value.subtype === 'วิญญาณเฝ้าห้อง' ? newItem.value.maxSpirits : null,
          cooldownHours: newItem.value.type === 'วิญญาณ' && ['วิญญาณเฝ้าห้อง', 'วิญญาณผู้พิทักษ์', 'วิญญาณดูดทรัพย์'].includes(newItem.value.subtype) ? newItem.value.cooldownHours : null,
          eliminatedRooms: newItem.value.type === 'วิญญาณ' && newItem.value.subtype === 'วิญญาณค้นหาผู้เล่น' ? newItem.value.eliminatedRooms : null,
          protectCount: newItem.value.type === 'วิญญาณ' && newItem.value.subtype === 'วิญญาณผู้พิทักษ์' ? newItem.value.protectCount : null,
          protectDurationHours: newItem.value.type === 'วิญญาณ' && newItem.value.subtype === 'วิญญาณผู้พิทักษ์' ? newItem.value.protectDurationHours : null,
          minDiamondLoot: newItem.value.type === 'วิญญาณ' && newItem.value.subtype === 'วิญญาณดูดทรัพย์' ? newItem.value.minDiamondLoot : null,
          maxDiamondLoot: newItem.value.type === 'วิญญาณ' && newItem.value.subtype === 'วิญญาณดูดทรัพย์' ? newItem.value.maxDiamondLoot : null
        };

        // Add item to gameItems collection
        await projectFirestore.collection('gameItems').doc(itemName).set(newItemData);
        console.log('Item added successfully:', itemName);
        emit('itemAdded');
        emit('cancelModal');
      } catch (error) {
        console.error('Error adding item:', error);
        alert(`เกิดข้อผิดพลาด: ${error.message}`);
      }
    };

    return {
      activeTab,
      newItem,
      handleAddItem,
      addDecompose,
      removeDecompose,
      totalDecomposeChance,
      addUpgradeMaterial,
      removeUpgradeMaterial,
      addExplorableMap,
      removeExplorableMap,
      addRequiredPreviousSpirit,
      removeRequiredPreviousSpirit
    };
  }
};
</script>

<style scoped>
.animate-fade-in {
  animation: fadeIn 0.5s ease-in;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>